import React from "react";
import Slider from "react-slick";
import Link from 'next/link';
import AnchorLink from 'react-anchor-link-smooth-scroll';

const Hero = (props) => {
    var settings = {
        dots: false,
        arrows: true,
        speed: 1200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        fade: true
    };

    return (
        <section className={`wpo-hero-slider ${props.heroClass}`}>
            <div className="hero-container">
                <div className="hero-wrapper">
                    <Slider {...settings}>
                        <div className="hero-slide">
                            <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${'/images/slider/slide-1.jpg'})` }}>
                                <div className="container-fluid">
                                    <div className="slide-content">
                                        <div className="slide-title">
                                            <h2>Confiança está no nosso DNA.</h2>
                                        </div>
                                        <div className="slide-text">
                                            <p>Atuamos há mais de 40 anos no mercado, trazendo as melhores suluções jurídicas a nossos clientes.</p>
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="slide-btns">
                                            <AnchorLink href='#contact-form' className='theme-btn'>Fale Conosco</AnchorLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="hero-slide">
                            <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${'/images/slider/slide-2.jpg'})` }}>
                                <div className="container-fluid">
                                    <div className="slide-content">
                                        <div className="slide-title">
                                            <h2>Atendimento exclusivo.</h2>
                                        </div>
                                        <div className="slide-text">
                                            <p>Prestamos um atendimento exclusivo para atender suas demandas.</p>
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="slide-btns">
                                            <Link href="/about" className="theme-btn">Fale Conosco</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default Hero;